<ion-header [translucent]="true">
  <ion-toolbar>
    @if(state.isMobile){
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        <ion-icon size="large" name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    }@else{
    <ion-buttons slot="end">
      <ion-button (click)="cancel()">
        <ion-icon size="large" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    }

    <ion-title> {{ this.name }} </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true" [scrollY]="false">
  <lib-viewer
    *ngIf="docLoaded"
    [docId]="this.docId"
    [docName]="this.name"
    [fileExtension]="this.fileExtension"
    [pdfType]="this.pdfType"
  ></lib-viewer>
</ion-content>
